import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(
    `${process.env.REACT_APP_API_HOST}/resume_certifications/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const get = async (id) => {
  return await httpClient.get(
    `${process.env.REACT_APP_API_HOST}/resume_certifications/${id}`,
  );
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(`resume_certifications/export/`, {
      responseType: 'blob',
      params: Object.assign(
        {},
        {
          'filter[tercero]': query,
          'page[number]': page,
          'page[size]': pageSize,
        },
        search ? { 'filter[search]': search } : {},
      ),
    });
  else
    return await httpClient.get(`resume_certifications/`, {
      params: Object.assign(
        {},
        {
          'filter[tercero]': query,
          'page[number]': page,
          'page[size]': pageSize,
        },
        search ? { 'filter[search]': search } : {},
      ),
    });
};

const put = async (id, data) => {
  return await httpClient.put(
    `${process.env.REACT_APP_API_HOST}/resume_certifications/${id}/`,
    data,
    {
      headers: {
        'Content-Type': `multipart/form-data;`,
      },
    },
  );
};

const remove = async (id) => {
  return await httpClient.delete(
    `${process.env.REACT_APP_API_HOST}/resume_certifications/${id}`,
  );
};

export { post, get, put, remove, ajaxTable };
